import { PlayCircle, Plus } from 'lucide-react';

export interface ClassesSetupHeaderProps {
  /** Without `CLASS_MANAGE` the add button is withheld. */
  canManage: boolean;
  onAddClass: () => void;
  onHowItWorks: () => void;
}

/** The quieter header buttons, beside the one that adds a class. */
const SECONDARY_BUTTON =
  'rounded-xl bg-white dark:bg-[#111c2e] hover:bg-slate-50 dark:hover:bg-[#16253d] text-slate-700 dark:text-slate-200 hover:text-slate-900 dark:hover:text-white px-4 py-2 border border-slate-200 dark:border-slate-800 text-sm font-bold inline-flex items-center gap-2 transition-all cursor-pointer shadow-xs focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500';

/** What this screen is, and what can be done from it. */
export function ClassesSetupHeader({
  canManage,
  onAddClass,
  onHowItWorks,
}: ClassesSetupHeaderProps) {
  return (
    <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3.5 min-w-0">
        <div className="min-w-0">
          <h1 className="text-xl sm:text-2xl font-extrabold tracking-tight text-slate-800 dark:text-white">
            Classes Setup
          </h1>
          <p className="text-xs sm:text-sm font-medium text-slate-500 dark:text-slate-400 mt-0.5">
            Organise your classes, sections, subjects and academic structure, all in one place.
          </p>
        </div>
      </div>

      <div className="flex items-center gap-3 shrink-0 flex-wrap">
        <button
          type="button"
          onClick={onHowItWorks}
          className={SECONDARY_BUTTON}
        >
          <PlayCircle className="h-4 w-4 text-indigo-500" />
          <span>How it works</span>
        </button>

        {canManage && (
          <button
            type="button"
            onClick={onAddClass}
            className="rounded-xl bg-indigo-600 tracking-wide hover:bg-indigo-700 text-white px-4 py-2 text-sm font-bold inline-flex items-center gap-2 transition-all cursor-pointer shadow-sm shadow-indigo-500/20 active:scale-[0.98] focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 focus-visible:ring-offset-2"
          >
            <Plus className="h-4 w-4 stroke-[2.5]" />
            <span>Add Class</span>
          </button>
        )}
      </div>
    </header>
  );
}
